import config from "../../config";

const base = config.api.baseUrl;
const ep = config.api.endpoints.basecampFranchiseReporting;

async function jsonOrThrow(res) {
  let body = null;
  try {
    body = await res.json();
  } catch (_) {
    // non-JSON response
  }
  if (!res.ok) {
    const err = new Error((body && body.error) || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

/** POST /start. Returns {status: "started"|"in_progress", job_id}. Treats 409 as a normal outcome.
 *  Pass retryOf (a job_id) to re-run only the stores that didn't succeed in that job. */
export async function startRun(retryOf) {
  const res = await fetch(`${base}${ep.start}`, {
    method: "POST",
    credentials: "include",
    ...(retryOf && {
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ retry_of: retryOf }),
    }),
  });
  let body = null;
  try {
    body = await res.json();
  } catch (_) {}
  if (res.status === 409) {
    return { status: "in_progress", job_id: body ? body.job_id : null };
  }
  if (!res.ok) {
    const err = new Error((body && body.error) || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

/** POST /cancel. Returns {status: "cancelling", job_id}. 409 when nothing is running. */
export async function cancelRun() {
  const res = await fetch(`${base}${ep.cancel}`, {
    method: "POST",
    credentials: "include",
  });
  return jsonOrThrow(res);
}

/** GET /current. Returns {has_active_run, job}. */
export async function fetchCurrent() {
  const res = await fetch(`${base}${ep.current}`, {
    method: "GET",
    credentials: "include",
  });
  return jsonOrThrow(res);
}

/** GET /jobs. Returns {jobs: [...summary]}. */
export async function fetchJobs() {
  const res = await fetch(`${base}${ep.jobs}`, {
    method: "GET",
    credentials: "include",
  });
  return jsonOrThrow(res);
}

/** GET /jobs/<id>. Returns {job}. */
export async function fetchJobDetail(jobId) {
  const res = await fetch(`${base}${ep.jobs}/${encodeURIComponent(jobId)}`, {
    method: "GET",
    credentials: "include",
  });
  return jsonOrThrow(res);
}

/** POST /jobs/<id>/publish. Copies the run's PDFs into the live Dashboards folder.
 *  Returns {status: "publishing", job_id}. 409 while a run or publish is active. */
export async function publishRun(jobId) {
  const res = await fetch(`${base}${ep.jobs}/${encodeURIComponent(jobId)}/publish`, {
    method: "POST",
    credentials: "include",
  });
  return jsonOrThrow(res);
}
